module.exports = __webpack_public_path__ + "static/images/components/RewardBox/images/small/rewardBox.524e2c86.png";


//////////////////
// WEBPACK FOOTER
// ./components/RewardBox/images/small/rewardBox.png
// module id = 2665
// module chunks = 11